import React from "react";
import {Card, CardContent, CardHeader, Container} from "@mui/material";
import { object, string, number, boolean, date, coerce } from 'zod';
import {formatDateTime, formatDateTimeParam, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import * as crudgen from "../../../../share";
import {DEBOUNCE_TIME} from "../../../../utils/constants";
import { GroupType, GroupTypePairs, toString as toStringGroupType } from "../../../types/models/GroupType.d";




























import { t, msg } from "@lingui/core/macro";
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import {useLocation} from "react-router";







export const initialFormStateFn = () => { return {
    
        
        email: "",
        
    
        
        hashPassword: "",
        
    
        
        activated: false,
        
    
        
        banned: false,
        
    
    }
}

export const useLocationFormState = () => {
    const initialFormState = initialFormStateFn()
    let location = useLocation();
    

    

    return React.useMemo(() => initialFormState, [
        location.state,
        
        
    ])
}

export const formObject = {
    
    
        email:
        string()
        .trim()
        .min(1, msg`Email is required`),
    
    
        hashPassword:
        string()
        .trim()
        .min(1, msg`Hash Password is required`),
    
    
        activated:
        boolean()
        ,
    
    
        banned:
        boolean()
        ,
    
};

export const formSchema = object(formObject);

const UserAddForm = ({watch, prefix = ''})  => {
    return (
        <Container>
           
           
   
   <crudgen.FormInput
       required
       name={ prefix + 'email' }
       aria-label="email"
       data-testid="email"
       label={t`Email`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormInput
       required
       name={ prefix + 'hashPassword' }
       aria-label="hashPassword"
       data-testid="hashPassword"
       label={t`Hash Password`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormCheckbox
       required
       name={ prefix + 'activated' }
       aria-label="activated"
       data-testid="activated"

       label={t`Activated`}
   />
   
   
           
           
   
   <crudgen.FormCheckbox
       required
       name={ prefix + 'banned' }
       aria-label="banned"
       data-testid="banned"

       label={t`Banned`}
   />
   
   
           
        </Container>
    )
}

export default UserAddForm;
